module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "finished-page"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "button is-large is-primary",
    class: {
      'is-loading': _vm.saving
    },
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_thanks']))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1357e00"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/task/FinishedPage.vue
// module id = 446
// module chunks = 0